import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../components/UserComponents";
import { successCheck } from "../../../assets/images";
import ConfettiExplosion from "react-confetti-explosion";
import axiosInstance from "../../../utils/api/axiosInstance";
import { USER_URL } from "../../../constants";
import { useDispatch } from "react-redux";
import { clearCart, loadCartFromServer } from "../../../redux/slices/CartSlice";
import { generateInvoice } from "../../../utils/generateInvoice";

const PaymentSuccess = ({ isCod = false, paymentStatus, order }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    async function updateCart() {
      try {
        const { data } = await axiosInstance(USER_URL + "/cart");
        dispatch(loadCartFromServer(data.data));
      } catch (e) {
        console.log(e.message);
      }
    }
    if (isCod) dispatch(clearCart());
    else if (paymentStatus === "success") updateCart();
  }, [dispatch, isCod, paymentStatus]);

  return (
    <div className="relative max-w-md bg-white-A700 p-6  mx-auto shadow-md rounded-md mt-5">
      <ConfettiExplosion duration={3000} width={2000} particleCount={200} />
      <div className="flex justify-center pb-2">
        <img src={successCheck} alt="Order placed" className="size-20" />
      </div>
      <div className="text-center">
        <h3 className="md:text-2xl text-base text-gray-900 font-semibold text-center">
          Order Placed!
        </h3>
        <p className="text-gray-600 my-2">Thank you for purchasing with us.</p>
        <p> Have a great day!</p>
        {isCod && (
          <div className="bg-gray-50 border border-blue-100 p-3 rounded-md my-3 ">
            <p className="text-blue-600 font-medium text-sm mb-2">
              Pay Now via UPI
            </p>
            <img
              src="/images/upiQR.jpg"
              alt="QR Code"
              className="w-40 h-40 object-cover rounded-sm mx-auto"
            />
          </div>
        )}

        <div className="flex items-center  flex-wrap justify-center gap-2 py-5 text-center">
          <Button
            shape="round"
            color="gray_900"
            className="px-4 py-2 sm:py-3  text-white-A700 font-medium !text-sm"
            onClick={() => generateInvoice(order)}
          >
            Download Invoice
          </Button>
          <button
            className="px-4 py-2 sm:py-3 bg-indigo-600 hover:bg-indigo-500 text-white-A700 font-medium !text-sm rounded-[26px]"
            onClick={() => navigate("/orders")}
          >
            Track order
          </button>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-green-500"></div>
    </div>
  );
};

export default PaymentSuccess;
